type Info = { min: number; price: number };

const multyPriceCalc = {
  rows: document.querySelectorAll(".jsInputRows") as NodeListOf<HTMLElement>,
  inputs: document.querySelectorAll(
    ".jsQtyInput"
  ) as NodeListOf<HTMLInputElement>,
  price: document.getElementById("jsTotalPrice") as HTMLElement | undefined,
  btn: document.getElementById("addToCartButton") as HTMLElement | undefined,
  init() {
    if (this.price) {
      this.setListenets();
      this.setReset();
    }
  },
  setListenets() {
    this.inputs.forEach((item) => {
      item.addEventListener("input", () => this.calcPrice());
    });
  },
  setReset() {
    this.btn?.addEventListener("click", () => {
      this.inputs.forEach((item) => {
        item.value = "0";
      });
      this.calcPrice();
    });
  },
  mapInfo(items: NodeListOf<HTMLElement>): Info[] {
    const info: Info[] = [];
    items.forEach((item) => {
      const min = item.dataset.min as string;
      const price = item.dataset.price as string;
      info.push({
        min: +min,
        price: +price,
      });
    });
    return info;
  },
  getPrice(info: Info[], qty: number) {
    let price = 0;
    info.forEach((item) => {
      if (item.min > qty) {
        return;
      }
      price = item.price;
    });
    return price;
  },
  calcPrice() {
    let sum = 0;
    this.rows.forEach((item) => {
      const input = item.querySelector(".jsQtyInput") as HTMLInputElement | undefined;
      if(input){
        const infoItem = item.querySelectorAll(
          ".jsPriceInfo"
        ) as NodeListOf<HTMLElement>;
        const info = this.mapInfo(infoItem);
        const qty = +input.value;
        const price = this.getPrice(info, qty);    
        sum += price * qty;
      }
    
    });
  
    this.price!.innerText = "$" + sum.toFixed(2);
  },
};

export default multyPriceCalc;
